module.exports = require("./vo-001.js");